import {IconButton} from '@wandb/components';
import React from 'react';

import {ChatIcon, ClockIcon} from './icons';
import type {Tab, useWbAgentChat} from './useWbAgentChat';

type Chat = ReturnType<typeof useWbAgentChat>;

const TABS: {key: Tab; label: string; icon: React.ReactNode}[] = [
  {key: 'messages', label: 'Messages', icon: <ChatIcon />},
  {key: 'history', label: 'History', icon: <ClockIcon />},
];

export const ChatTabs: React.FC<{chat: Chat}> = ({chat}) => (
  <div className="flex h-[34px] min-h-[34px] items-center gap-2 border-b border-[#E8E8E9] bg-white px-10">
    {TABS.map(tab => {
      const isActive = chat.activeTab === tab.key;
      return (
        <div
          key={tab.key}
          onClick={() => chat.setActiveTab(tab.key)}
          className={`-mb-px flex cursor-pointer select-none items-center gap-4 border-b-2 px-8 py-4 transition-colors duration-100 ${
            isActive
              ? 'border-[#038194] text-[#2B3038]'
              : 'border-transparent text-[#8F949E] hover:text-[#3F464F]'
          }`}>
          {tab.icon}
          <span
            className={`text-[12px] ${isActive ? 'font-semibold' : 'font-normal'}`}>
            {tab.label}
          </span>
        </div>
      );
    })}
    <div className="ml-auto">
      <IconButton
        size="sm"
        variant="ghost"
        onPress={chat.newConversation}
        icon="add-new"
        aria-label="New conversation"
      />
    </div>
  </div>
);
